<template>
  <div class="oravitaAnina">
    <h1>caile ferate Oraviţa-Anina, Banater Semmeringbahn</h1>
    <article>
      Doriţi o prelungare? Faceţi un click pe o posa!
Posele marcat cu "nn" nu sânt de la mine.<br/>
				Klicken Sie auf ein Foto, 
				um eine Vergrößerung zu erhalten<br>
				Mit (nn) markierte Fotos stammen nicht von mir.
    </article>
    <article class="fotos">
      
      <div class="foto">
        <img src="../assets/fotos/Bahnhof_Oravita_kl.jpg" width="125" height="110" border="0" alt="Bahnhof, gara: Oraviţa"
        @click="callImageClick('Bahnhof, gara: Oraviţa', 'Bahnhof_Oravita.jpg', $event)">
        <br>Bahnhof, gara: Oraviţa
      </div>
      <div class="foto">
        <img src="../assets/fotos/Bahnhof_Oravita_2kl.jpg" width="125" height="110" border="0" alt="Bahnhof, gara: Oraviţa"
        @click="callImageClick('Bahnhof, gara: Oraviţa', 'Bahnhof_Oravita_2.jpg', $event)">
        <br>Bahnhof, gara: Oraviţa
      </div>
      <div class="foto">
        <img src="../assets/fotos/Bahnhof_Oravita_3kl.jpg" width="125" height="110" border="0" alt="Bahnhof, gara: Oraviţa"
        @click="callImageClick('Bahnhof, gara: Oraviţa', 'Bahnhof_Oravita_3.jpg', $event)">
        <br>Bahnhof, gara: Oraviţa
      </div>
      <div class="foto">
        <img src="../assets/fotos/Bahnhof_Oravita_4kl.jpg" width="125" height="110" border="0" alt="Bahnhof, gara: Oraviţa"
        @click="callImageClick('Bahnhof, gara: Oraviţa', 'Bahnhof_Oravita_4.jpg', $event)">
        <br>Bahnhof, gara: Oraviţa
      </div>
      <div class="foto">
        <img src="../assets/fotos/Bahnhof_Oravita_5kl.jpg" width="125" height="110" border="0" alt="Bahnhof, gara: Oraviţa"
        @click="callImageClick('Bahnhof, gara: Oraviţa', 'Bahnhof_Oravita_5.jpg', $event)">
        <br>Bahnhof, gara: Oraviţa
      </div>
      <div class="foto">
        <img src="../assets/fotos/Ora-Ani_Zug_kl.jpg" width="125" height="110" border="0" alt="caile ferate Oraviţa-Anina, Banater Semmeringbahn"
        @click="callImageClick('caile ferate Oraviţa-Anina, Banater Semmeringbahn', 'Ora-Ani_Zug.jpg', $event)">
        <br>Bahnstrecke / caile ferate Oraviţa - Anina
      </div>
      <div class="foto">
        <img src="../assets/fotos/Ora-Ani_Bruecke_kl.jpg" width="125" height="110" border="0" alt="caile ferate Oraviţa-Anina, Banater Semmeringbahn"
        @click="callImageClick('caile ferate Oraviţa-Anina, Banater Semmeringbahn', 'Ora-Ani_Bruecke.jpg', $event)">
        <br>Bahnstrecke / caile ferate Oraviţa - Anina
      </div>
      <div class="foto">
        <img src="../assets/fotos/Ora-Ani_Bruecke_2kl.jpg" width="125" height="110" border="0" alt="caile ferate Oraviţa-Anina, Banater Semmeringbahn"
        @click="callImageClick('caile ferate Oraviţa-Anina, Banater Semmeringbahn', 'Ora-Ani_Bruecke_2.jpg', $event)">
        <br>Bahnstrecke / caile ferate Oraviţa - Anina
      </div>
      <div class="foto">
        <img src="../assets/fotos/Ora-Ani_2Tunnel_kl.jpg" width="125" height="110" border="0" alt="caile ferate Oraviţa-Anina, Banater Semmeringbahn"
        @click="callImageClick('caile ferate Oraviţa-Anina, Banater Semmeringbahn', 'Ora-Ani_2Tunnel.jpg', $event)">
        <br>Bahnstrecke / caile ferate Oraviţa - Anina
      </div>
      <div class="foto">
        <img src="../assets/fotos/Ora-Ani_Felsen_kl.jpg" width="125" height="110" border="0" alt="caile ferate Oraviţa-Anina, Banater Semmeringbahn"
        @click="callImageClick('caile ferate Oraviţa-Anina, Banater Semmeringbahn', 'Ora-Ani_Felsen.jpg', $event)">
        <br>Bahnstrecke / caile ferate Oraviţa - Anina
      </div>
      <div class="foto">
        <img src="../assets/fotos/Ora-Ani_Felseinschnitt_kl.jpg" width="125" height="110" border="0" alt="caile ferate Oraviţa-Anina, Banater Semmeringbahn"
        @click="callImageClick('caile ferate Oraviţa-Anina, Banater Semmeringbahn', 'Ora-Ani_Felseinschnitt.jpg', $event)">
        <br>Bahnstrecke / caile ferate Oraviţa - Anina
      </div>
      <div class="foto">
        <img src="../assets/fotos/oran_1kl.jpg" width="125" height="110" border="0" alt="caile ferate Oraviţa-Anina, Banater Semmeringbahn"
        @click="callImageClick('caile ferate Oraviţa-Anina, Banater Semmeringbahn', 'oran_1.jpg', $event)">
        <br>Bahnstrecke / caile ferate Oraviţa - Anina
      </div>
      <div class="foto">
        <img src="../assets/fotos/oran_2kl.jpg" width="125" height="110" border="0" alt="caile ferate Oraviţa-Anina, Banater Semmeringbahn"
        @click="callImageClick('caile ferate Oraviţa-Anina, Banater Semmeringbahn', 'oran_2.jpg', $event)">
        <br>Bahnstrecke / caile ferate Oraviţa - Anina
      </div>
      <div class="foto">
        <img src="../assets/fotos/oran_3kl.jpg" width="125" height="110" border="0" alt="caile ferate Oraviţa-Anina, Banater Semmeringbahn"
        @click="callImageClick('caile ferate Oraviţa-Anina, Banater Semmeringbahn', 'oran_3.jpg', $event)">
        <br>Bahnstrecke / caile ferate Oraviţa - Anina
      </div>
      <div class="foto">
        <img src="../assets/fotos/oran_4kl.jpg" width="125" height="110" border="0" alt="caile ferate Oraviţa-Anina, Banater Semmeringbahn"
        @click="callImageClick('caile ferate Oraviţa-Anina, Banater Semmeringbahn', 'oran_4.jpg', $event)">
        <br>Bahnstrecke / caile ferate Oraviţa - Anina
      </div>
      <div class="foto">
        <img src="../assets/fotos/oran_5kl.jpg" width="125" height="110" border="0" alt="caile ferate Oraviţa-Anina, Banater Semmeringbahn"
        @click="callImageClick('caile ferate Oraviţa-Anina, Banater Semmeringbahn', 'oran_5.jpg', $event)">
        <br>Bahnstrecke / caile ferate Oraviţa - Anina
      </div>
      <div class="foto">
        <img src="../assets/fotos/oran_6kl.jpg" width="125" height="110" border="0" alt="caile ferate Oraviţa-Anina, Banater Semmeringbahn"
        @click="callImageClick('caile ferate Oraviţa-Anina, Banater Semmeringbahn', 'oran_6.jpg', $event)">
        <br>Bahnstrecke / caile ferate Oraviţa - Anina
      </div>
      <div class="foto">
        <img src="../assets/fotos/oran_7kl.jpg" width="125" height="110" border="0" alt="caile ferate Oraviţa-Anina, Banater Semmeringbahn"
        @click="callImageClick('caile ferate Oraviţa-Anina, Banater Semmeringbahn', 'oran_7.jpg', $event)">
        <br>Bahnstrecke / caile ferate Oraviţa - Anina
      </div>
      <div class="foto">
        <img src="../assets/fotos/oran_8kl.jpg" width="125" height="110" border="0" alt="caile ferate Oraviţa-Anina, Banater Semmeringbahn"
        @click="callImageClick('caile ferate Oraviţa-Anina, Banater Semmeringbahn', 'oran_8.jpg', $event)">
        <br>Bahnstrecke / caile ferate Oraviţa - Anina
      </div>
      <div class="foto">
        <img src="../assets/fotos/oran_9kl.jpg" width="125" height="110" border="0" alt="caile ferate Oraviţa-Anina, Banater Semmeringbahn"
        @click="callImageClick('caile ferate Oraviţa-Anina, Banater Semmeringbahn', 'oran_9.jpg', $event)">
        <br>Bahnstrecke / caile ferate Oraviţa - Anina
      </div>
      <div class="foto">
        <img src="../assets/fotos/oran_10kl.jpg" width="125" height="110" border="0" alt="caile ferate Oraviţa-Anina, Banater Semmeringbahn"
        @click="callImageClick('caile ferate Oraviţa-Anina, Banater Semmeringbahn', 'oran_10.jpg', $event)">
        <br>Bahnstrecke / caile ferate Oraviţa - Anina
      </div>
      <div class="foto">
        <img src="../assets/fotos/oran_11kl.jpg" width="125" height="110" border="0" alt="caile ferate Oraviţa-Anina, Banater Semmeringbahn"
        @click="callImageClick('caile ferate Oraviţa-Anina, Banater Semmeringbahn', 'oran_11.jpg', $event)">
        <br>Bahnstrecke / caile ferate Oraviţa - Anina
      </div>
      <div class="foto">
        <img src="../assets/fotos/oran_12kl.jpg" width="125" height="110" border="0" alt="Bahnhof, gara: Anina"
        @click="callImageClick('Bahnhof, gara: Anina', 'oran_12.jpg', $event)">
        <br>Bahnhof, gara: Anina
      </div>
      <div class="foto">
        <img src="../assets/fotos/Bahnhof_Anina_kl.jpg" width="125" height="110" border="0" alt="Bahnhof, gara: Anina"
        @click="callImageClick('Bahnhof, gara: Anina', 'Bahnhof_Anina.jpg', $event)">
        <br>Bahnhof, gara: Anina
      </div>
      <div class="foto">
        <img src="../assets/fotos/Bahnhof_Anina_2kl.jpg" width="125" height="110" border="0" alt="Bahnhof, gara: Anina"
        @click="callImageClick('Bahnhof, gara: Anina', 'Bahnhof_Anina_2.jpg', $event)">
        <br>Bahnhof, gara: Anina
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'home',
  methods: {
  callImageClick(imgText, imgName, event) {
     this.$parent.handleImageClick(imgText, imgName, event);
    }
  }
}
</script>